import React from 'react';
import Box from 'fe-design-base/atoms/Box';

import SelectInput from 'components/forms/SelectInput';
import Text from 'components/Text';

import { cxFunction } from 'util/className';
import { toI18n } from 'util/i18n';

import { HIRED_FROM_OPTIONS } from '../../../hiring/constants';
const HiringSourceSelect = ({
  cx,
  hiredFromValue,
  onHiredFromChange,
  payrollEnrolled,
}) => (
  <Box className={cx()} mt={10} mb={32} maxw={payrollEnrolled ? '100%' : 235}>
    <Box mb={8}>
      <Text fw600 fs14 i18n="add_team.individual_drawer.hired_from.label" />
    </Box>
    <SelectInput
      hideClear
      placeholder={toI18n('add_team.individual_drawer.hired_from.placeholder')}
      searchable={false}
      value={hiredFromValue}
      options={HIRED_FROM_OPTIONS}
      onChange={onHiredFromChange}
    />
  </Box>
);

export default cxFunction('HiringSourceSelect', HiringSourceSelect);
